import { takeLatest, delay } from 'redux-saga'
import { take, call, race, put } from 'redux-saga/effects'

import actionTypes from '../actions/actionTypes'
import callAny from 'redux/sagas/helpers/call_any'
import {
	getOEQData,
} from 'sync/teacher_sync'
import sessionActionCreators from 'redux/actions/sessionActions'

function *getStudentsProxyCaller(action) {
	try {
		const response = yield callAny(
			getOEQData,
			action.session.device_uid,
			action.slide.slideId,
			action.session.headers)
		const questionData = action.questionData
		const answerKey = questionData.options[0].key
		const participation = response.participation.total
			? Math.round(response.participation.completed / response.participation.total * 100)
			: 0
		const answers = response.answers.map(answer => (
			{
				participantUid: answer.uid,
				nickname: answer.nickname,
				answer: answer.answers[answerKey] || '',
			}
		))
		yield put(sessionActionCreators.oeqStudentDataFetched(
			answers,
			participation,
			action.slide_uid,
		))
	} catch (err) {
		//
	}
}

function *initializeOeqPolling(action) {
	while (true) {
		yield call(getStudentsProxyCaller, action)
		yield call(delay, 8000)
	}
}

function *waitForOEQFinalization() {
	yield take(actionTypes.SESSION_TEACHER_OEQ_FINALIZE)
}

function *initializeOeq(action) {
	yield race([
		call(initializeOeqPolling, action),
		call(waitForOEQFinalization),
	])
}

export default [
	takeLatest(actionTypes.SESSION_TEACHER_OEQ_INITIALIZE, initializeOeq),
]


export {
	initializeOeqPolling,
}
